<template>
  <div class="background-white">
    <AppHeader
      :title="$store.state.language === 'en' ? 'Maung' : 'မောင်း'"
      :show-back="true"
      :has-actions="true"
    />

    <div class="bet-footer fb-bet-bar">
      <div class="fb-bet-bar__surface">
        <div class="fb-bet-bar__row">
          <div class="fb-bet-bar__side fb-bet-bar__side--left">
            <span class="fb-bet-bar__type">{{ $store.state.language === 'en' ? 'Maung' : 'မောင်း' }}</span>
            <span class="fb-bet-bar__badge">{{ getFBOrder.fb_matches.length }}</span>
          </div>
          <div class="fb-bet-bar__field-wrap">
            <input
              type="number"
              ref="amount"
              v-model="amount"
              class="fb-bet-bar__input amount"
              :placeholder="$store.state.language === 'en' ? 'Amount (MMK)' : 'ငွေပမာဏ'"
            />
            <small v-if="errors.amount" class="fb-bet-bar__error">{{ errors.amount }}</small>
          </div>
          <button
            type="button"
            class="fb-bet-bar__submit"
            @click="setToPreviewVoucher()"
          >
            {{ $store.state.language === 'en' ? 'Bet' : 'ထိုးမည်' }}
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="this.football.is_kyay_open"
      class="px-2"
    >
      <!-- <h1
        class="text-center my-2 py-1"
        style="
                background: #0F8606;
                color: white;
                border-radius: 5px;
                font-size: 15px;
                text-decoration: underline;
            "
        @click="$router.push('/live-score')"
      >
        {{
          $store.state.language === "en"
            ? "Live Score Result"
            : "ပွဲတိုက်ရိုက် ရလဒ်များ"
        }}
      </h1> -->
      <h1
        class="text-center my-2 py-1"
        style="
                background: #0F8606;
                color: white;
                border-radius: 5px;
                font-size: 15px
            "
      >
        {{
          $store.state.language === "en"
            ? "Today"
            : "ယနေ့"
        }}
        <span>&nbsp;{{ drawDate }}&nbsp;</span>
        {{
          $store.state.language === "en"
            ? "Matches"
            : "ပွဲများ"
        }}
        <i
          class="fas fa-long-arrow-alt-up"
          style="color: #16a34a"
          v-if="isToday"
          @click="changeToday"
        ></i>
        <i
          class="fas fa-long-arrow-alt-down"
          style="color: #16a34a"
          v-if="!isToday"
          @click="changeToday"
        ></i>
      </h1>

      <div
        class="d-flex my-3 justify-content-end"
        v-if="matches.length > 0"
      >
        <div
          class="col-6 d-flex justify-content-center"
          v-if="filteredMatches.length > 0"
        >
          <i
            class="fas fa-redo my-auto mr-2 text-lg"
            @click="resetFilter()"
          ></i>
          <div
            class="text-uppercase text-danger"
            @click="resetFilter()"
          >
            {{
              $store.state.language === "en"
                ? "Reset Filter"
                : "ပွဲစဉ်များအားလုံး။"
            }}
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <i
            class="fas fa-filter my-auto text-lg"
            @click="filterModalBox()"
          ></i>
          <div
            class="text-uppercase"
            @click="filterModalBox()"
          >
            {{
              $store.state.language === "en"
                ? "Filter By League"
                : "လိဒ်ဖြင့် စစ်ထုတ်ခြင်း။"
            }}
          </div>
        </div>
      </div>

      <div>
        <!-- Loading state -->
        <div
          class="text-center align-items-center mt-5 pt-5"
          v-if="matches.length === 0 && isLoading"
        >
          <Loading
            color="#0F8606"
            size="24"
            class="px-4 py-0 m-auto pb-2 pt-5"
          />
          <span class="text-danger font-weight-bold">
            {{
              $store.state.language === "en"
                ? "Please wait."
                : "ဘောလုံးပွဲစဉ်များအား ရယူနေပါသည်။"
            }}
            <br>
            {{
              $store.state.language === "en"
                ? "Football matches are fetching!"
                : "ခေတ္တစောင့်ဆိုင်းပေးပါ။"
            }}
          </span>
        </div>

        <!-- Empty state -->
        <div
          class="text-center align-items-center mt-5 pt-5"
          v-else-if="matches.length === 0 && !isLoading"
        >
          <span class="text-muted font-weight-bold">
            {{
              $store.state.language === "en"
                ? "No football matches found."
                : "ဘောလုံးပွဲစဉ် မရှိသေးပါ။"
            }}
          </span>
        </div>

        <!-- Matches list -->
        <div
          class="p-1 mb-5 pb-2"
          v-else-if="isToday"
        >
          <FootballTeamCard
            v-for="(match, index) in filteredMatches.length > 0 ? filteredMatches : matches"
            :key="index"
            :match="match"
            :on-my-event="myEventSource"
          />
        </div>
      </div>

      <!-- <div
            v-for="(league, leagueIndex) in leagues"
            :key="leagueIndex"
            v-show="isToday && isLeagueHasMatches(league.fbmatches)"
            class="card"
        > -->
      <!-- <div>
                <h3 class="ml-2 pl-2 mt-2">{{ league.name }}</h3>
            </div> -->
      <!-- </div> -->
      <div class="col-lg-4 col-md-6 px-2">
        <div class="row">
          <!-- === only amount === -->
          <div class="col-md-4 cart-voucher">
            <div
              class="modal fade"
              id="mobile-voucher"
              ref="mobileVoucherModalRoot"
              tabindex="-1"
              role="dialog"
              aria-labelledby="modal-form"
              aria-hidden="true"
            >
              <div
                class="
                                modal-dialog
                                modal-
                                modal-dialog-centered
                                modal-lg
                            "
                role="document"
              >
                <div class="modal-content">
                  <div
                    class="text-center modal-cross"
                    @click="closeModal"
                  >
                    X
                  </div>
                  <div class="modal-body p-0">
                    <FBPreviewVoucher
                      @remove="removeHistory"
                      type="maung"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- === only amount === -->
      <div class="col-md-4">
        <div
          class="modal fade"
          id="amount"
          ref="amountModalRoot"
          tabindex="-1"
          role="dialog"
          aria-labelledby="modal-form"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal- modal-dialog-centered modal-lg"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-body">
                <div class="card border-0 mb-0">
                  <div class="card-body px-lg-5 py-lg-5">
                    <div class="form-group mb-3">
                      {{
                        $store.state.language === "en"
                          ? "Enter Amount"
                          : "ငွေပမာဏထည့်ပါ"
                      }}
                      <div class="
                                                mt-2
                                                input-group
                                                input-group-merge
                                                input-group-alternative
                                            ">
                        <div class="input-group-prepend">
                          <span class="input-group-text"><i class="
                                                            ni ni-money-coins
                                                        "></i></span>
                        </div>
                        <input
                          class="form-control"
                          type="number"
                          v-model="amount"
                        />
                      </div>
                      <span class="text-danger">{{
                        errors.amount
                      }}</span>
                    </div>
                    <div class="text-center">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="setToPreviewVoucher()"
                      >
                        {{
                          $store.state.language === "en"
                            ? "Continue"
                            : "ဆက်သွားမည်"
                        }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="bet-container">
          <button
            class="btn btn-primary"
            @click="showModalBox"
            style="background-color: #0F8606; border: none; color: white;"
          >
            {{
              $store.state.language === "en"
                ? "Bet"
                : "လောင်းမည်"
            }}
          </button>
        </div> -->
      </div>

      <!-- === leagues filter === -->
      <div class="col-md-4">
        <div
          class="modal fade"
          id="league-box"
          ref="leagueModalRoot"
          tabindex="-1"
          role="dialog"
          aria-labelledby="modal-form"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal- modal-dialog-centered modal-lg"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-body">
                <div class="border-0 py-3 px-3">
                  <span
                    class="text-dark mb-2 text-lg"
                    style="font-weight: 500;"
                  >
                    {{
                      $store.state.language === "en"
                        ? "Please select leagues to filter!"
                        : "ပွဲစဉ်များ စစ်ထုတ်ရန် လိဒ် တစ်ခုခုရွေးချယ်ပေးပါ။"
                    }}
                  </span>
                  <div
                    class="mb-4 mt-2"
                    style="height: 50vh; overflow-y: scroll;"
                  >
                    <van-checkbox-group
                      v-model="checkedLeagues"
                      shape="square"
                    >
                      <van-checkbox
                        :name="league"
                        class="my-2"
                        v-for="(league, index) in currentLeagues"
                        :key="index"
                      >{{ league }}</van-checkbox>
                    </van-checkbox-group>
                  </div>
                  <button
                    type="button"
                    class="btn btn-success mt-4 mx-auto"
                    style="padding-left: 1.5rem !important; padding-right: 1.5rem !important;"
                    @click="closeFilterModal()"
                  >
                    DONE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="bet-container">
          <button
            class="btn btn-danger"
            @click="showModalBox"
            style="background-color: #0F8606; border: none; color: white;"
          >
            {{
              $store.state.language === "en"
                ? "Bet"
                : "လောင်းမည်"
            }}
          </button>
        </div> -->
      </div>

    </div>
  </div>
</template>
<script>
import { Loading, Dialog } from 'vant';
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { newEventSource } from 'vue-parent-emit';
import FootballTeamCard from './components/FootballTeamCard.vue';
import FBPreviewVoucher from './components/FBPreviewVoucher.vue';
import AppHeader from './components/AppHeader.vue';

export default {
  components: { FootballTeamCard, FBPreviewVoucher, Loading, AppHeader },
  data() {
    return {
      myEventSource: newEventSource(),
      isGoalPor: false,
      matches: [],
      leagues: [],
      // historyLeagues: [],
      isMobile: false,
      amount: null,
      football: {},
      errors: {},
      isHistory: false,
      isToday: true,
      isLoading: true,
      checkedLeagues: [],
      currentLeagues: [],
      filteredMatches: [],
    };
  },
  computed: {
    ...mapGetters(['getFBOrder']),
    drawDate() {
      return this.matches[0]?.draw_date ?? '-';
    },
  },
  watch: {
    checkedLeagues() {
      this.filteredMatches = this.matches.filter(match => {
        const isExist = this.checkedLeagues.filter(league => league === match.league)
        if (isExist.length > 0) return true;
        else false;
      })
    }
  },
  methods: {
    ...mapActions(['fetchUser']),
    closeFilterModal() {
      $('#league-box').modal('hide');
    },
    moveModalsToBody() {
      const modalRefs = [
        this.$refs.mobileVoucherModalRoot,
        this.$refs.amountModalRoot,
        this.$refs.leagueModalRoot,
      ];

      modalRefs.forEach((el) => {
        if (el && el.parentNode && el.parentNode !== document.body) {
          document.body.appendChild(el);
        }
      });
    },
    resetFilter() {
      this.checkedLeagues = [];
    },
    filterModalBox() {
      $('#league-box').modal('show');
    },
    isLeagueHasMatches(matches) {
      let matchesTotal = 0;

      for (let i = 0; i < matches.length; i += 1) {
        let isShow = true;
        // if (nowTime.getHours() >= 12) {
        //   if (matches[i].close_time.A === 'PM') {
        //     matchTime.setHours(
        //       parseInt(matches[i].close_time.hh, 10) + 12,
        //       parseInt(matches[i].close_time.mm, 10) - 5,
        //       0,
        //     );
        //     isShow = matchTime > nowTime;
        //   }
        // } else {
        //   if (matches[i].close_time.A === 'AM') {
        //     matchTime.setHours(
        //       parseInt(
        //         matches[i].close_time.hh === '12'
        //           ? 0
        //           : matches[i].close_time.hh,
        //         10,
        //       ),
        //       parseInt(matches[i].close_time.mm, 10) - 5,
        //       0,
        //     );
        //   } else {
        //     isShow = false;
        //   }
        //   isShow = matchTime > nowTime;
        // }
        const matchTime = new Date(this.match.start_time);
        const nowTime = new Date();
        isShow = matchTime > nowTime;
        if (isShow) matchesTotal += 1;
      }
      if (matchesTotal > 0) return true;
      return false;
    },
    sendEvent() {
      this.myEventSource.emit();
    },
    changeHistory() {
      this.isHistory = !this.isHistory;
    },
    changeToday() {
      this.isToday = !this.isToday;
    },
    ...mapMutations(['updateFBOrder', 'setWholeFBMatches', 'setBetAmount']),
    closeModal() {
      $('#mobile-voucher').modal('hide');
    },
    showModalBox() {
      $('#amount').modal('show');
    },
    removeHistory() {
      this.setWholeFBMatches([]);
      this.setBetAmount(null);
      this.sendEvent();
    },
    setToPreviewVoucher() {
      this.errors = {};
      if (!this.amount) {
        this.errors.amount = this.$store.state.language === 'en'
          ? 'Please enter amount'
          : 'ငွေပမာဏ ထည့်ပေးပါ။';
        return false;
      }
      if (this.amount < this.football.min_maung_fees) {
        this.errors.amount = this.$store.state.language === 'en'
          ? `Please enter amount more than ${this.football.min_maung_fees}`
          : `${this.football.min_maung_fees} ထက်ပိုထည့်ပေးပါ။`;
        return false;
      }
      if (this.amount > this.football.max_maung_fees) {
        this.errors.amount = this.$store.state.language === 'en'
          ? `Please enter amount less than ${this.football.max_maung_fees}`
          : `${this.football.max_maung_fees} အောက်ထည့်ပေးပါ။`;
        return false;
      }
      const matches = this.getFBOrder.fb_matches;
      this.setBetAmount(this.amount);
      for (let i = 0; i < matches.length; i += 1) {
        matches[i].bet_amount = this.amount;
      }
      this.setWholeFBMatches(matches);
      $('#amount').modal('hide');
      this.openModalVoucher();
      return true;
    },
    openModalVoucher() {
      if (this.$store.state.fb_order.fb_matches.length === 0) {
        const dataError = this.$store.state.language === 'en'
          ? 'Please select some teams!'
          : 'အသင်းတစ်ချို့ ရွေးပေးပါ။';
        this.dialog(dataError);
      } else {
        const matches = this.getFBOrder.fb_matches;
        let isBetAmount = true;
        for (let index = 0; index < this.getFBOrder.fb_matches.length; index += 1) {
          const fbMatch = this.getFBOrder.fb_matches[index];
          if (!fbMatch.bet_amount) {
            isBetAmount = false;
          }
        }
        if (!isBetAmount) {
          $('#amount').modal('show');
        } else {
          $('#mobile-voucher').modal('show');
        }
      }
    },
    dialog(text) {
      Dialog.alert({
        message: text,
        confirmButtonText:
          this.$store.state.language === 'en'
            ? 'Go Back'
            : 'နောက်သို့ပြန်သွားမည်။',
      }).then(() => {
        // on close
      });
    },
    async fetchMatches() {
      try {
        const res = await axios.get('fb-matches', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          params: {
            isFromClient: true,
          },
        });
        this.matches = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchLeagues() {
      try {
        this.isLoading = true;
        const date = new Date();
        // const res = await axios.get('/leagues-fb-matches');
        await this.fetchMatches();
        // const historyRes = await axios.get(
        //   '/leagues-fb-matches-history',
        //   {
        //     headers: {
        //       Authorization: `Bearer ${localStorage.getItem('token')}`,
        //     },
        //   }
        // );
        // this.historyLeagues = historyRes.data.data;
        for (let index = 0; index < this.matches.length; index += 1) {
          // league filtering
          const match = this.matches[index];
          const isLeague = this.currentLeagues.filter(league => league === match.league)
          if (isLeague.length === 0) {
            this.currentLeagues.push(match.league)
          }

          if (this.matches[index].kyayed_team === this.matches[index].first_team) {
            this.matches[index].kyayed_team = this.$store.state.language === 'en'
              ? this.matches[index].first_team_en
              : this.matches[index].first_team;
          } else if (this.matches[index].kyayed_team === this.matches[index].second_team) {
            this.matches[index].kyayed_team = this.$store.state.language === 'en'
              ? this.matches[index].second_team_en
              : this.matches[index].second_team;
          }

          this.matches[index].first_team = this.$store.state.language === 'en'
            ? this.matches[index].first_team_en
            : this.matches[index].first_team;

          this.matches[index].second_team = this.$store.state.language === 'en'
            ? this.matches[index].second_team_en
            : this.matches[index].second_team;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    async fetchFootball() {
      try {
        const res = await axios.get('/football', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.football = res.data.data[0];
        this.checkIsKyayOpen();
      } catch (error) {
        console.log(error);
      }
    },
    ready() {
      if (!this.$pusher || typeof this.$pusher.subscribe !== 'function') return;
      const channel = this.$pusher.subscribe('football-channel');
      channel.bind('football-matches', async (data) => {
        if (data.callApi) this.fetchLeagues();
      });
    },
    checkIsKyayOpen() {
      if (this.football && !this.football.is_kyay_open) {
        const text = this.$store.state.language === 'en'
          ? 'Football Kyay not open yet.'
          : 'ဘောလုံးကြေးမဖွင့်သေးပါ။';
        Dialog.alert({
          message: text,
          confirmButtonText:
            this.$store.state.language === 'en'
              ? 'Go Back'
              : 'နောက်သို့ပြန်သွားမည်။',
        }).then(() => {
          // on close
          this.$router.push('/home');
        });
      }
    },
  },
  destroyed() {
    $('#mobile-voucher').modal('hide');
    $('#amount').modal('hide');
    $('#league-box').modal('hide');

    const modalRefs = [
      this.$refs.mobileVoucherModalRoot,
      this.$refs.amountModalRoot,
      this.$refs.leagueModalRoot,
    ];
    modalRefs.forEach((el) => {
      if (el && el.parentNode === document.body) {
        document.body.removeChild(el);
      }
    });

    this.setBetAmount(null);
    this.setWholeFBMatches([]);
    if (this.$pusher && typeof this.$pusher.unsubscribe === 'function') {
      this.$pusher.unsubscribe('football-channel');
    }
  },
  async created() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    this.updateFBOrder({ type: 'type', value: 'maung' });
    // this.fetchMatches();
    await this.fetchFootball();
    await this.fetchLeagues();
    this.$nextTick(() => {
      this.moveModalsToBody();
    });
    // this.checkIsKyayOpen();

    this.ready();
    // if (window.innerWidth < 768) {
    //   this.isMobile = true;
    // }
  },
};
</script>
<style scoped>
.bet-container {
  position: fixed;
  bottom: 0;
  margin-bottom: 5vh;
  width: 300px;
  right: 0;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.25em;
  color: white;
  z-index: 100;
  visibility: visible;
  opacity: 1;
}

.modal-cross {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  padding-top: 3px;
  margin-left: auto;
  color: white;
  cursor: pointer;
  margin-right: -9px;
  margin-top: -9px;
  background: rgb(228, 87, 87);
}

@media (max-width: 768px) {
  .bet-container {
    width: 100px;
  }
}

.bet-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 100%;
  height: auto;
  z-index: 20;
}

.fb-bet-bar__surface {
  background: linear-gradient(180deg, #2a2a2a 0%, #3d3d3d 50%, #4a4a4a 100%);
  border-top: 1px solid rgba(74, 222, 128, 0.35);
  box-shadow: 0 -10px 28px rgba(0, 0, 0, 0.32);
  padding: 0.65rem 0.75rem calc(0.65rem + env(safe-area-inset-bottom, 0px));
  border-radius: 16px 16px 0 0;
}

.fb-bet-bar__row {
  display: flex;
  align-items: flex-end;
  gap: 0.55rem;
  flex-wrap: nowrap;
}

.fb-bet-bar__side--left {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;
  min-width: 3.75rem;
}

.fb-bet-bar__type {
  font-size: 0.72rem;
  font-weight: 800;
  color: #e5e7eb;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.1;
}

.fb-bet-bar__hint {
  font-size: 0.62rem;
  font-weight: 600;
  color: rgba(209, 213, 219, 0.85);
  line-height: 1.1;
}

.fb-bet-bar__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.75rem;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #15803d 0%, #22c55e 100%);
  color: #fff;
  font-size: 0.8rem;
  font-weight: 800;
  box-shadow: 0 2px 8px rgba(34, 197, 94, 0.35);
}

.fb-bet-bar__field-wrap {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.fb-bet-bar__input {
  width: 100%;
  height: 42px;
  border: 1px solid #9ca3af;
  border-radius: 11px;
  padding: 0 0.7rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1f2937;
  background: #f3f4f6;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);
}

.fb-bet-bar__input::placeholder {
  color: #6b7280;
  font-weight: 500;
}

.fb-bet-bar__input:focus {
  outline: none;
  border-color: #22c55e;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.28);
}

.fb-bet-bar__error {
  display: block;
  font-size: 0.65rem;
  color: #bef264;
  line-height: 1.25;
  margin: 0;
  padding-left: 2px;
}

.fb-bet-bar__submit {
  flex: 0 0 auto;
  align-self: flex-end;
  min-width: 4.75rem;
  height: 42px;
  padding: 0 0.9rem;
  border: none;
  border-radius: 11px;
  font-weight: 800;
  font-size: 0.82rem;
  letter-spacing: 0.02em;
  color: #fff;
  background: linear-gradient(135deg, #166534 0%, #22c55e 55%, #4ade80 100%);
  box-shadow: 0 3px 12px rgba(22, 101, 52, 0.45);
  cursor: pointer;
  white-space: nowrap;
}

.fb-bet-bar__submit:active {
  transform: scale(0.98);
  opacity: 0.96;
}

#mobile-voucher,
#amount,
#league-box {
  z-index: 10050 !important;
}
</style>
